import React, { useState } from 'react';
import './ContactForm.css';

function ContactForm() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    position: '',
    message: ''
  });
  const [submitStatus, setSubmitStatus] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus('sending');

    try {
      // Fake endpoint - replace with real one later
      const response = await fetch('https://api.frumreferrals.com/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          company: '',
          position: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    }
  };

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Your Name"
          required
        />
      </div>
      <div className="form-group">
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Your Email"
          required
        />
      </div>
      <div className="form-group">
        <input
          type="text"
          name="company"
          value={formData.company}
          onChange={handleChange}
          placeholder="Your Company"
          required
        />
      </div>
      <div className="form-group">
        <input
          type="text"
          name="position"
          value={formData.position}
          onChange={handleChange}
          placeholder="Your Position"
          required
        />
      </div>
      <div className="form-group">
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          placeholder="Tell us any information that you feel like would be helpful"
          required
        ></textarea>
      </div>
      <button type="submit" className="submit-button" disabled={submitStatus === 'sending'}>
        {submitStatus === 'sending' ? 'Sending...' : 'Submit Application'}
      </button>
      {submitStatus === 'success' && (
        <p className="success-message">Thank you for your interest! We'll be in touch soon.</p>
      )}
      {submitStatus === 'error' && (
        <p className="error-message">Something went wrong. Please try again later.</p>
      )}
    </form>
  );
}

export default ContactForm; 